import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "47",
  fill: "none",
  viewBox: "0 0 32 47"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#3B4E85",
      d: "M23.875 29.012V46.73L16 40.823 8.125 46.73V29.01z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#7481A6",
      d: "M16 32.106c8.699 0 15.75-7.052 15.75-15.75S24.698.605 16 .605.25 7.656.25 16.355 7.302 32.106 16 32.106"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F0DF70",
      d: "m16 22.52-6.084 3.2 1.162-6.776-4.922-4.799 6.802-.988L16 6.992l3.042 6.165 6.802.988-4.922 4.799 1.162 6.775z"
    }, null, -1)
  ])))
}
export default { render: render }